<template>
    <CRow>
        <CDataTable
            class="col-12 px-0"
            :items="Object.values(agreements)"
            :fields="$dataTableFieldsMaker(fields)"
            hover
            :pagination="{ ...pagination, change: fetchAgreements }"
            addTableClasses="bg-white"
        >
            <template #user="{item}">
                <td>{{ item.user ? item.user.full_name : '---' }}</td>
            </template>

            <template #startedAt="{item}">
                <td dir="ltr" class="text-center">{{ item.started_at ? $moment(item.started_at).format('jYYYY/jMM/jDD') : '--' }}</td>
            </template>

            <template #finishedAt="{item}">
                <td dir="ltr" class="text-center">{{ item.finished_at ? $moment(item.finished_at).format('jYYYY/jMM/jDD') : '--' }}</td>
            </template>

            <template #file="{item}">
                <td class="text-center">
                    <CLink @click="() => showPdf(item)">مشاهده</CLink>
                </td>
            </template>

            <template #createdAt="{item}">
                <td dir="ltr" class="text-center">{{ $moment(item.created_at).format('jYYYY/jMM/jDD') }}</td>
            </template>

            <template #updatedAt="{item}">
                <td dir="ltr" class="text-center">{{ item.updated_at ? $moment(item.updated_at).format('jYYYY/jMM/jDD') : '--' }}</td>
            </template>

            <template #type="{item}">
                <td>
                    <span class="">{{ typeStr(item) }}</span>
                </td>
            </template>

            <template #status="{item}">
                <td>
                    <span :class="'badge badge-' + statusColor(item)">{{ statusStr(item) }}</span>
                </td>
            </template>

            <template #isLocked="{item}">
                <td class="text-center">
                    {{ item.is_locked ? 'بلی' : 'خیر' }}
                </td>
            </template>

            <template #actions="{item}">
                <td>
                    <CLink
                        class="mfs-1"
                        @click="deleteModal = { show: true, item: Object.assign({}, item) }"
                        v-if="$policy('agreement', item).soft_delete"
                    >
                        <FaIcon icon="trash" class="text-danger" />
                    </CLink>
                    <CLink
                        class="mfs-1"
                        @click="showEditModal(item)"
                        v-if="$policy('agreement', item).edit"
                    >
                        <FaIcon icon="edit" class="text-info" />
                    </CLink>
                </td>
            </template>
        </CDataTable>

        <CModal v-if="deleteModal.show" :title="$t('agreement.delete')" color="danger" :show.sync="deleteModal.show">
            {{ $t('agreement.are_you_sure_to_remove', { attribute: deleteModal.item.user.full_name }) }}
            <template
                #footer
            >
                <CButton @click="deleteModal = {item: {}, show: false}" color="secondary">{{ $t('cancel') }}</CButton>
                <CButton @click="submitDeleteForm" color="danger">{{ $t('delete') }}</CButton>
            </template>
        </CModal>
        <CModal :show.sync="editModal.show">
            <template #header-wrapper>
                <div></div>
            </template>

            <Form :submit="submit" :agreement="editModal.item" ref="agreementForm" class="px-1 pt-3" />

            <template #footer-wrapper>
                <div></div>
            </template>
        </CModal>
        <CModal :show.sync="pdfItem.show" size="xl">
            <template #header-wrapper>
                <span></span>
            </template>

            <iframe :src="pdfItem.src" style="width: 100%;border: 0px;height: 500px;border-radius: 5px;background-color: transparent;"></iframe>
            <template #footer-wrapper>
                <span></span>
            </template>
        </CModal>
    </CRow>
</template>

<script>
import Form from './Form'
import fields from './fields'
import { AgreementStatus, AgreementType } from '@/constants'
import { mapGetters, mapActions } from 'vuex'
import { statusStr, statusColor, typeStr } from './methods'
import { uploadService } from '@/services/api'

export default {
    name: 'List',

    components: {
        Form
    },

    data() {
        return {
            AgreementStatus,
            AgreementType,
            fields,
            deleteModal: {
                show: false,
                item: {},
            },
            editModal: {
                show: false,
                item: {},
            },
            pdfItem: {
                src: '',
                show: false,
            },
        }
    },

    computed: {
        ...mapGetters({
            agreements: 'agreement/agreements',
            pagination: 'agreement/pagination',
            filterMeFields: 'filterMeComponent/filterMeFields',
        }),
    },

    methods: {
        statusStr,
        statusColor,
        typeStr,
        ...mapActions({
            fetch: 'agreement/fetch',
            edit: 'agreement/edit',
            deleteAgreement: 'agreement/delete',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            toastComponent: 'toastComponent/setCToast',
        }),
        async showPdf(agreement) {
            let href = agreement.file
            if (agreement.file.indexOf("api/files/secrets") !== -1) {
                let result = await uploadService.getSecret(agreement.file)
                href = result.data ? result.data.data.url : ''
            }

            // this.pdfItem.src = base ? `data:application/pdf;base64, ${base}` : ''
            this.pdfItem.src = href
            this.pdfItem.show = true
        },
        showEditModal(item) {
            this.setShowLoading(false)
            this.resetMsg()

            this.$refs.agreementForm.$refs.form.reset()
            this.$refs.agreementForm.destory()

            this.editModal = { show: true, item: Object.assign({}, item) }
        },
        fetchAgreements(activePage, params = false) {
            this.fetch({
                page: activePage,
                ...params,
                ...this.filterMeFields
            })

            this.pagination.page = activePage
        },
        submitDeleteForm() {
            this.deleteAgreement(this.deleteModal.item.id).then(() => this.deleteModal.show = false)
        },
        submit() {
            const agreementForm = this.$refs.agreementForm
            this.setShowLoading()
            this.resetMsg()

            this.edit(this.editModal.item).then(() => {
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.updateAgreement'),
                    type: 'success'
                })
                agreementForm.$refs.form.reset()
                agreementForm.destory()
            }).catch(result => {
                if (result.data) {
                    agreementForm.$refs.form.setErrors(result.data);
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.' + result.tag),
                    type: 'danger'
                })
            })
        },
    },
}
</script>